    import card1 from './components/img/card1.jpg'
    import card2 from './components/img/card2.jpg'
    import card3 from './components/img/card3.jpg'
    import card4 from './components/img/card4.jpg'
    import card5 from './components/img/card5.jpg'
    import card6 from './components/img/card6.jpg'
    import card7 from './components/img/card7.jpg'
    import card8 from './components/img/card8.jpg'
    import card9 from './components/img/card9.jpg'
    import card20 from './components/img/card20.jpg'
    import card22 from './components/img/card22.jpg'
    import card58 from './components/img/card58.jpg'
    import card59 from './components/img/card59.jpg'
    import watch3 from './components/img/watch3.jpg'
    import watch2 from './components/img/watch2.jpg'
    import phone2 from './components/img/phone2.jpg'
    import card65 from './components/img/card65.jpg'
    import card38 from './components/img/card38.jpg'
    import card33 from './components/img/card33.jpg'
    import card31 from './components/img/card31.jpg'
    import card30 from './components/img/card30.jpg'
    import card52 from './components/img/card52.jpg'
    import card23 from './components/img/card23.jpg'
    import card63 from './components/img/card63.jpg'
    import card62 from './components/img/card62.jpg'
    import card67 from './components/img/card67.jpg'
    import card82 from './components/img/card82.jpg'
    import card57 from './components/img/card57.jpg'
    import book1 from './components/img/book1.jpg'
    import book2 from './components/img/book2.jpg'


const list = [
        {
        id: 1,
        ID:'E-book',
        title: "E-Book My First Book of Pencil Control",
        author: "by Wonder House Books | 25 April 2018",
        price: 120.55,
        img: `${card1}`,
        progress:88,
        sold: 15,
        offer:'NEW',
        amount:1,
        link:'SingleCard1',
        SASA:'E-Books Product'
        },
        {
        id: 2,
        title: "Be A High Achiever [E-Book] - Allround Achievers",
        author: "by Wonder House Books | 25 April 2018",
        price: 110.55,
        img: `${book1}`,
        progress:79,
        sold: 28,
        offer:'NEW',
        amount:1,
        link:'SingleCard10',
        SASA:'E-Books Product'
        },
        {
        id: 3,
        title: "Budgeting 6E - 6th Edition by William R Lalli (book)",
        author: "by Wonder House Books | 25 April 2018",
        price: 135.55,
        img: `${book2}`,
        progress:95,
        sold: 19,
        offer:'NEW',
        amount:1,
        link:'SingleCard11',
        SASA:'E-Books Product'
        },
        {
        id: 4,
        title: "Sound Intone 165 Earphone White Version",
        author: "by Maple Press  | 1 September 2020",
        price: 222.99 ,
        img: `${card2}`,
        progress:95,
        sold: 17,
        offer:'OFF',
        amount:1,
        link:'SingleCard2',
        SASA:'Technology Product',
        ID:'Technology Product'
        },
        {
        id: 5,
        title: "Beat Spill 2.0 Wireless Speaker - White AZ",
        author: "by Om Books Editorial Team | 30 September 2020",
        price: 135.55,
        img: `${card6}`,
        progress:97,
        sold: 22,
        offer:'BEST',
        amount:1,
        link:'SingleCard6',
        SASA:'Technology Product'
        },
        {
        id: 6,
        title: "Edifier Powered Bookshelf Speakers AZ",
        author: "by Wonder House Books  | 6 December 2020",
        price: 189.55,
        img: `${card8}`,
        progress:77,
        sold: 30,
        offer:'BEST',
        amount:1,
        link:'SingleCard8',
        SASA:'Technology Product'
        },

        {
        id: 7,
        IDfur:'Furniture Product',
        title: "Korea  Sofa Fabric In Blue Navy Color AZ",
        author: "by Om Books Editorial Team  | 25 November 2018",
        price: 1043.55,
        img: `${card3}`,
        progress:78,
        sold: 10,
        offer:'OFF',
        amount:1,
        link:'SingleCard3',
        SASA:'Furniture Product',
        ID:'Furniture Product',
        },
        {
        id: 8,
        title: "Claure Austin Lover Round Chair White Wooden",
        author: "by Om Books Editorial Team  | 25 November 2018",
        price: 320.55,
        img: `${card58}`,
        progress:98,
        sold: 15,
        offer:'OFF',
        amount:1,
        link:'SingleCard12',
        SASA:'Furniture Product'
        },
        {
        id:9,
        title: "Korea Fabric Chair In Brown Color AZ",
        author: "by Om Books Editorial Team  | 25 November 2018",
        price: 443.99,
        img: `${card59}`,
        progress:88,
        sold: 11,
        offer:'OFF',
        amount:1,
        link:'SingleCard13',
        SASA:'Furniture Product'
        },
        

        {
        id: 10,
        title: "Mymt Classical Leather Watch In Black",
        author: "by Wonder House Books  | 1 January 2018",
        price: 149.55,
        img: `${card5}`,
        progress:93,
        sold: 19,
        offer:'NEW',
        amount:1,
        link:'SingleCard5',
        SASA:'Watch Product',
        ID:'Watch Product'
        
        },
        {
        id:11,
        title: "Diesel Men's Mega Chief Quartz Stainless Steel ",
        author: "by Wonder House Books  | 1 January 2018",
        price: 358.99,
        img: `${watch3}`,
        progress:93,
        sold: 19,
        offer:'NEW',
        amount:1,
        link:'SingleCard3',
        SASA:'Watch Product'
        },
        {
        id:12,
        title: "Re16gio Mormaii Ana16gico Maui MOPC21 JAH8P Preto",
        author: "by Wonder House Books  | 1 January 2018",
        price: 249.55,
        img: `${watch2}`,
        progress:93,
        sold: 19,
        offer:'NEW',
        amount:1,
        link:'SingleCard3',
        SASA:'Watch Product'
        },

        {
            id: 13,
            title: "LG White Front Load Steam VVasher AZ",
            author: "by Om Books Editorial Team  | 1 January 2021",
            price: 1442.57,
            img: `${card7}`,
            progress:82,
            sold: 8,
            offer:'NEW',
            amount:1,
            link:'SingleCard7',
            SASA:'Electronic Product',
            ID:'Electronic Product'
        },
        {
            id: 14,
            title: "Amcrest Security Camera in White Color",
            author: "by Content Team at Target Publications",
            price: 550.99,
            img: `${card9}`,
            progress:85,
            sold: 24,
            offer:'NEW',
            amount:1,
            link:'SingleCard9',
            SASA:'Electronic Product'
        },
        {
            id: 15,
            title: "Zero ZR-200 Wired Gaming Mouse - Black",
            author: "by Maple Press | 1 September 2021",
            price: 86.55,
            img: `${card20}`,
            progress:83,
            sold: 17, 
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Electronic Product'
        },
        // Clothing //////////////////////////////////////////
        {
            id: 16,
            title: "Unero Military Classical Backoack AZ",
            author: "by Wonder House Books | 25 April 2018",
            price: 57.55,
            img: `${card4}`,
            progress:92,
            sold: 12,
            offer:'OFF',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product',
            ID:'Clothing Product'
        },
        {
            id: 17,
            title: "POLO RALPH LAUREN Mesh Contrast Trims Logo Polo Shirt",
            author: "by Wonder House Books | 25 April 2018",
            price: 145.55,
            img: `${card38}`,
            progress:79,
            sold: 18,
            offer:'OFF',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product'
        },
        {
            id: 18,
            title: "Polo Ralph Lauren Regular Fit Tipped Polo Shirt",
            author: "by Wonder House Books | 25 April 2018",
            price: 180.55,
            img: `${card33}`,
            progress:82,
            sold: 22,
            offer:'OFF',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product'
        },
        {
            id: 19,
            title: "Sports Fitness Clothing Men's Tight-fitting - 08 / L ",
            author: "by Wonder House Books | 25 April 2018",
            price: 127.55,
            img: `${card31}`,
            progress:100,
            sold: 30,
            offer:'NEW',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product'
        },
        {
            id: 20,
            title: "Marmot Camp Hauler Medium 2023 in Brown I Polyester",
            author: "by Wonder House Books | 25 April 2018",
            price: 457.55,
            img: `${card30}`,
            progress:89,
            sold: 16,
            offer:'OFF',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product'
        },
        {
            id: 21,
            title: "Embry Riddle  Eagles Erau Pullover Hoodie Sweatshirt",
            author: "by Wonder House Books | 25 April 2018",
            price: 257.55,
            img: `${card52}`,
            progress:82,
            sold: 8,
            offer:'BEST',
            amount:1,
            link:'SingleCard4',
            SASA:'Clothing Product'
        },
        //Smart phone
        {
            id: 22,
            title: "OPPO A78 256GB, 8GB RAM Smart Phone ",
            author: "by Rebecca Smith  | 14 December 2021",
            price: 7890.5,
            img: `${card22}`,
            progress:98,
            sold: 11,
            offer:'BEST',
            amount:1,
            link:'SingleCard3',
            SASA:'Smart Product',
            ID:'Smart Product'
        },
        {
            id: 23,
            title: "XIAOMI Mi 11 Lite - 128 GB Zwart 5G (Smart)",
            author: "by Rebecca Smith  | 14 December 2021",
            price: 6390.9,
            img: `${phone2}`,
            progress:93,
            sold: 15,
            offer:'BEST',
            amount:1,
            link:'SingleCard3',
            SASA:'Smart Product'
        },
        {
            id: 24,
            title: "Apple iPhone 14 Pro Max, 5G, 256GB, Gold",
            author: "by Rebecca Smith  | 14 December 2021",
            price: 30000.5,
            img: `${card23}`,
            progress:97,
            sold: 19,
            offer:'BEST',
            amount:1,
            link:'SingleCard3',
            SASA:'Smart Product'
        },

        //Home&Kichen

        {
            id: 25,
            title: "Black & Decker 1000W Stand Mixer AZ ",
            author: "by Sudha Murty | 1 January 2015",
            price: 4880.45,
            img: `${card65}`,
            progress:90,
            sold: 19,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product',
            ID:'Home&Kichen Product'
        },
        {
            id: 26,
            title: "Nutribullet (red) Hi-speed Blender/mixer, 8-piece Set",
            author: "by Sudha Murty | 1 January 2015",
            price: 2599.9,
            img: `${card63}`,
            progress:88,
            sold: 20,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product'
        },
        {
            id: 27,
            title: "KENMORE ELITE 18-Piece Stainless Steel Cutlery ",
            author: "by Sudha Murty | 1 January 2015",
            price: 480.55,
            img: `${card62}`,
            progress:79,
            sold: 12,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product'
        },
        {
            id: 28,
            title: "Ergonomic Computer Chair Office Chair Electric Competitive",
            author: "by Sudha Murty | 1 January 2015",
            price: 1880.5,
            img: `${card82}`,
            progress:95,
            sold: 17,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product'
        },
        {
            id: 29,
            title: "Gallon Water Dispenser, Water 5 Jug Pump,electric Water Pump For 5 Gallon Bottle",
            author: "by Sudha Murty | 1 January 2015",
            price: 880.9,
            img: `${card67}`,
            progress:85,
            sold: 16,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product'
        },
        {
            id: 30,
            title: "AROMA 20-Cup Silver Rice Cooker with Food Steamer and Slow Cooker Functions",
            author: "by Sudha Murty | 1 January 2015",
            price: 1200.45,
            img: `${card57}`,
            progress:80,
            sold: 12,
            offer:'NEW',
            amount:1,
            link:'SingleCard3',
            SASA:'Home&Kichen Product'
        },
];  


export default list